import React from 'react';
import { Form, Col, Row } from 'react-bootstrap';
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GoogleLogin } from '@react-oauth/google';
//import { useLogin } from 'react-facebook';
import useAuth from 'hooks/useAuth';
//import { Navigate } from 'react-router-dom';

const SocialAuthButtons = () => {
 /* const { login, status, isLoading, error } = useLogin();

 async function handleLogin() {
  try {
   const response = await login({
    scope: 'email'
   });

   console.log(response);
  } catch (error) {
   console.log(error.message);
  }
 } */

 const { initGoogle } = useAuth('googlesignup');

 return (
  <Form.Group className="mb-0">
   <Row>
    <Col sm={12} className="pe-sm-1">
     {/* <Button
          variant=""
          size="sm"
          className="btn-outline-google-plus mt-2 w-100"
        >
          <FontAwesomeIcon
            icon={['fab', 'google-plus-g']}
            transform="grow-8"
            className="me-2"
          />{' '}
          google
        </Button> */}
     <GoogleLogin
      onSuccess={credentialResponse => {
       initGoogle(credentialResponse);
      }}
      onError={() => console.log('Fallo la coneccion')}
     />
    </Col>
    {/* <Col sm={12} className="ps-sm-1">
          <Button
            variant=""
            size="sm"
            className="btn-outline-facebook mt-2 w-100"
            onClick={handleLogin}
            disabled={isLoading}
          >
            <FontAwesomeIcon
              icon={['fab', 'facebook-square']}
              transform="grow-8"
              className="me-2"
            />{' '}
            facebook
          </Button>
        </Col> */}
   </Row>
  </Form.Group>
 );
};

export default SocialAuthButtons;
